// styling
import styles from './styles.module.scss';

// components
import { ReactComponent as Goal } from '@assets/goal.svg';
import InfoTabsNav from '@components/InfoTabsNav';
import LazyImage from '@components/LazyImage';
import Spring from '@components/Spring';

// hooks
import { useThemeProvider } from '@contexts/themeContext';
import PropTypes from 'prop-types';

// assets
import kroos from '@assets/kroos.webp';

const PlayerFullInfo = ({player, playerName}) => {
    const {direction} = useThemeProvider();
    const composedName = [player?.first_name ?? player?.firstName, player?.last_name ?? player?.lastName]
        .filter(Boolean)
        .join(' ');
    const name = player?.name || composedName || playerName || 'Captain';
    const number = player?.number ?? player?.shirt_number ?? player?.shirtNumber ?? '—';
    const position = player?.position ?? player?.role ?? 'Captain';
    const image = player?.image ?? player?.image_url ?? player?.avatar ?? kroos;

    return (
        <Spring className="card h-2 d-flex flex-column">
            <div className="p-relative flex-1">
                <div className={`${styles.main} ${styles[direction]} d-flex flex-column g-16`}>
                    <span className="player-number">{number}</span>
                    <div className="d-flex flex-column">
                        <h2 className="text-20">{name}</h2>
                        <span className="text-12">{position}</span>
                    </div>
                </div>
                <LazyImage className={`${styles.media} ${styles[direction]}`} src={image} alt={name} />
                <Goal className={styles.goal}/>
            </div>
            <InfoTabsNav/>
        </Spring>
    )
}

PlayerFullInfo.propTypes = {
    player: PropTypes.object,
    playerName: PropTypes.string,
};

export default PlayerFullInfo
